'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $nav = {
  menu_trigger: '.nav-mobile-menu-trigger',
  subnav_trigger: '.nav-mobile-menu-item.has-subnav',
  mobile_search_trigger: '.nav-mobile-search .icon-search',
  dropdown_header: '.dropdown-header'
};

/**
*
* ------------------------------------------------------------------------------
*
*
* @namespace global
*/

var $global = {
  category_toggle_cta: '.category-toggle-cta',
  modal_trigger_open: '.modal-trigger-open',
  modal_trigger_close: '.modal-trigger-close',
  modal_overlay: '.modal-overlay',
  modal_container: '.modal-container, .info-modal-container'
};

var $receive_date = '';

listeners();

if ((0, _jquery2.default)('#pdp-shipping-copy').length) {
  calculate_delivery_estimates();
}

function listeners() {

  if (location.href.indexOf("#sidecart") != -1) {
    (0, _jquery2.default)('body').addClass('sidecart-open');
  }

  (0, _jquery2.default)(document).on('click', $nav.menu_trigger, function () {
    (0, _jquery2.default)('body').removeClass('mobile-search-open');
    (0, _jquery2.default)('body').toggleClass('mobile-menu-open');
  });
  (0, _jquery2.default)(document).on('click', $nav.subnav_trigger, function () {
    (0, _jquery2.default)(this).toggleClass('subnav-open');
  });
  (0, _jquery2.default)(document).on('click', $nav.dropdown_header, function () {
    (0, _jquery2.default)(this).toggleClass('open');
  });
  (0, _jquery2.default)(document).on('click', $nav.mobile_search_trigger, function () {
    (0, _jquery2.default)('body').removeClass('mobile-menu-open');
    (0, _jquery2.default)('body').toggleClass('mobile-search-open');
  });
  (0, _jquery2.default)(document).on('click', $global.category_toggle_cta, function () {
    var type = (0, _jquery2.default)(this).attr('show');
    (0, _jquery2.default)('.category-toggle-section').attr('show', type);
  });

  // Modals
  (0, _jquery2.default)(document).on('click', $global.modal_trigger_open, function () {
    var modal = (0, _jquery2.default)(this).attr('modal');
    (0, _jquery2.default)('.modal-container[modal="' + modal + '"]').addClass('open');
    (0, _jquery2.default)($global.modal_overlay).addClass('open');
  });
  (0, _jquery2.default)(document).on('click', $global.modal_trigger_close, function () {
    var modal = (0, _jquery2.default)(this).attr('modal');
    (0, _jquery2.default)($global.modal_container).removeClass('open');
    (0, _jquery2.default)($global.modal_overlay).removeClass('open');
  });
  if (location.href.indexOf("?contact_posted=true") != -1) {
    (0, _jquery2.default)($global.modal_overlay).addClass('open');
    (0, _jquery2.default)('.info-modal-container').addClass('open');
    var url = document.location.protocol + "//" + document.location.hostname + document.location.pathname;
    // document.location = url;
    window.history.replaceState(null, null, url);
  }
}

function calculate_delivery_estimates() {
  var $time = new Date();
  $time.setTime($time.getTime() + $time.getTimezoneOffset() * 60 * 1000);

  var offset = -240;
  var $time_est = new Date($time.getTime() + offset * 60 * 1000);
  var $hour_est = $time_est.getHours();
  var $day_est = $time_est.getDay();

  // If Tuesday before 12pm EST
  if ($day_est == 2 && $hour_est < 13) {
    (0, _jquery2.default)('.pdp-shipping-receive-day').text('this Thursday');
    (0, _jquery2.default)('.pdp-shipping-receive-day-alt').text('Thursday');
    var $hours_left = 13 - $hour_est;
    (0, _jquery2.default)('.pdp-shipping-hours-left').text(' if you order in the next ' + $hours_left + ' hours');
  } else if ($day_est == 2 && $hour_est >= 13) {
    (0, _jquery2.default)('.pdp-shipping-receive-day').text('this Friday');
    (0, _jquery2.default)('.pdp-shipping-receive-day-alt').text('Friday');
    var $hours_left = 24 - $hour_est + 13;
    (0, _jquery2.default)('.pdp-shipping-hours-left').text(' if you order in the next ' + $hours_left + ' hours');
  } else if ($day_est == 3 && $hour_est < 13) {
    (0, _jquery2.default)('.pdp-shipping-receive-day').text('this Friday');
    (0, _jquery2.default)('.pdp-shipping-receive-day-alt').text('Friday');
    var $hours_left = 13 - $hour_est;
    (0, _jquery2.default)('.pdp-shipping-hours-left').text(' if you order in the next ' + $hours_left + ' hours');
  } else if ($day_est == 3 && $hour_est >= 13) {
    (0, _jquery2.default)('.pdp-shipping-receive-day').text('next Wednesday');
    (0, _jquery2.default)('.pdp-shipping-receive-day-alt').text('Wednesday');
    var $hours_left = 24 - $hour_est + 13;
    (0, _jquery2.default)('.pdp-shipping-hours-left').text(' if you order in the next ' + $hours_left + ' hours');
  } else if ($day_est > 3) {
    (0, _jquery2.default)('.pdp-shipping-receive-day').text('next Wednesday');
    (0, _jquery2.default)('.pdp-shipping-receive-day-alt').text('Wednesday');
  } else if ($day_est == 1 && $hour_est < 13) {
    (0, _jquery2.default)('.pdp-shipping-receive-day').text('this Wednesday');
    (0, _jquery2.default)('.pdp-shipping-receive-day-alt').text('Wednesday');
    var $hours_left = 13 - $hour_est;
    (0, _jquery2.default)('.pdp-shipping-hours-left').text(' if you order in the next ' + $hours_left + ' hours');
  } else if ($day_est == 1 && $hour_est >= 13) {
    (0, _jquery2.default)('.pdp-shipping-receive-day').text('this Thursday');
    (0, _jquery2.default)('.pdp-shipping-receive-day-alt').text('Thursday');
    var $hours_left = 24 - $hour_est + 13;
  }
}